import { useState } from "react";
import { TypedFilter } from "odata-query";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import {
  AccountType,
  IAccountListResponse,
  IApiRequest,
} from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getAccountsUUID = createUUID();

export const useAccounts = ({
  accountTypes = [],
}: {
  accountTypes?: AccountType[];
} = {}) => {
  const [accounts, setAccounts] = useState<IAccountListResponse[]>([]);
  const [filter, setFilter] = useState<TypedFilter<IAccountListResponse>>({});

  const stateManager = useComponentState();

  const getAccounts = ({
    top,
    skip,
    filters,
    sort,
    params,
    search = "",
  }: IApiRequest = {}) => {
    stateManager.abort(getAccountsUUID);

    return stateManager.run(async () => {
      const response = await accountService.accounts.getAll({
        sort: sort ?? "name asc",
        top,
        skip,
        params,
        filters: {
          ...filter,
          ...(filters ?? {}),
          ...(accountTypes.length > 0 && { accountType: { in: accountTypes } }),
          or: [{ name: { contains: search } }, { code: { contains: search } }],
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        setAccounts(response.data);
      }
      return response;
    }, getAccountsUUID);
  };

  return {
    isLoading: stateManager.isBusy(),
    accounts,
    setAccounts,
    getAccounts,
    filter,
    setFilter,
  };
};
